// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"B8-z"};